const FaqPage = () => {
  return (
    <div style={{ paddingTop: "180px" }}>
      <h1>Centre d'Aide et FAQ</h1>
      <p>
        Vous avez des questions ? Voici des réponses aux questions fréquemment
        posées.
      </p>
      <div>
        <h2>Comment puis-je m'inscrire ?</h2>
        <p>
          Rendez-vous sur la page d'inscription et remplissez le formulaire...
        </p>

        <h2>Comment puis-je accéder à mon compte ?</h2>
        <p>
          Pour vous connecter, cliquez sur le bouton "Connexion" en haut à
          droite...
        </p>
      </div>
    </div>
  );
};

export default FaqPage;
